var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-container"},[_c('div',{staticClass:"empty-svg-area"},[_c('svg-empty',{staticClass:"svg"})],1),_c('div',{staticClass:"empty-text-area"},[_c('span',[_vm._v(_vm._s(_vm.text || _vm.t('noData')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }